import React, { ReactElement } from 'react';

import { Icon as SidebarIcon } from '@iconify/react';

import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import { ImageGeneratorRoute } from '~/modules/image-generator';
import { ImageGeneratorSidebarKey } from '~/modules/image-generator/constants';
import analytics from '~/services/analytics';

router.addPrivateRoutes([ImageGeneratorRoute]);

sidebar.addItems({
  a: [
    {
      order: 4,
      key: ImageGeneratorSidebarKey,
      path: ImageGeneratorRoute.path,
      getTitle: ImageGeneratorRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'image_generator',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            icon={isActive ? 'mdi:paintbrush' : 'mdi:paintbrush-outline'}
          />
        );
      },
    },
  ],
});
